import styled from 'styled-components';

export const TimelineContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 1 1 100%;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue;
  line-height: 1.42857142857143;
  height: 100%;
`;

export const Col = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 0 0 ${props => props.size};
  max-width: ${props => props.size};
  white-space: nowrap;
`;
